import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { Context as ContextType } from '../design/app';

export const Context = createContext<[ContextType, Dispatch<SetStateAction<ContextType>>] | null>(null);
